var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogoIflex = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6258 1.00024H4.30804C2.50366 1.00024 1 2.43476 1 4.15617V11.1375C1 11.3765 1.20049 11.6156 1.50122 11.6156H12.0769V1.47841C12.0769 1.19151 11.8764 1.00024 11.6258 1.00024ZM1.90219 10.7549V4.15617C1.90219 2.86511 3.00487 1.86095 4.30804 1.86095H11.1747V10.7549H1.90219Z",
    fill: "#F7A823",
    stroke: "#F7A823",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50122 13.3846C1.25061 13.3846 1 13.5767 1 13.8649V20.8778C1 22.607 2.45353 24 4.30804 24H12.0769V13.3846H1.50122ZM11.2249 14.2492V23.1834H4.30804C2.95475 23.1834 1.90219 22.1267 1.90219 20.8778V14.2492H11.2249Z",
    fill: "#76B82A",
    stroke: "#76B82A",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6769 1H14.3762C14.1245 1 13.9231 1.19301 13.9231 1.43427V11.6154H24.4965C24.7483 11.6154 25 11.3741 25 11.1329V4.18462C25 2.44755 23.5399 1 21.6769 1ZM24.0937 4.18462V10.8434H14.779V1.82028H21.6769C22.986 1.82028 24.0937 2.88182 24.0937 4.18462Z",
    fill: "#8682D9",
    stroke: "#8682D9",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4988 13.3846H13.9231V24H21.692C23.4964 24 25 22.6007 25 20.8636V13.8671C25 13.6258 24.7494 13.3846 24.4988 13.3846ZM24.1479 14.2049V20.8154C24.1479 22.1181 23.0453 23.1314 21.7421 23.1314H14.8253V14.2049H24.1479Z",
    fill: "#F15C43",
    stroke: "#EA5C0B",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6263 7.48718H10.3738C8.94133 7.48718 7.76929 8.61039 7.76929 9.98319V15.0168C7.76929 16.3896 8.94133 17.5128 10.3738 17.5128H15.6263C17.0588 17.5128 18.2308 16.3896 18.2308 15.0168V9.98319C18.2308 8.61039 17.0588 7.48718 15.6263 7.48718ZM17.4929 9.98319V15.0168C17.4929 16.0152 16.6681 16.8056 15.6263 16.8056H10.3738C9.33201 16.8056 8.50724 16.0152 8.50724 15.0168V9.98319C8.50724 8.98479 9.33201 8.19439 10.3738 8.19439H15.6263C16.6247 8.19439 17.4929 9.02639 17.4929 9.98319Z",
    fill: "#3A7CFF",
    stroke: "#3A7CFF",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoIflex, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-iflex.0b46524c.svg";
export { ForwardRef as ReactComponent };